import * as React from 'react';

import { compose, withProps } from 'recompose';

import User from 'js/lib/user';

import type { PropsFromWithSkillSetSaving } from 'bundles/program-home/components/ProgramHomeApp';
import { withSkillSetSaving } from 'bundles/program-home/components/ProgramHomeApp';
import { useProgram } from 'bundles/unified-common/contexts/EnterpriseProgramContext';
import EnterpriseUserSkillProfileContext from 'bundles/unified-home-common/contexts/enterprise/EnterpriseUserSkillProfileContext';

export const EnterpriseUserSkillProfileProvider = ({
  children,
  userSkillProfileStates,
  userSkillProfileStatesLoading,
  shouldRefetchUserSkillProfileStates,
  setShouldRefetchUserSkillProfileStates,
  onSkillSetSaveToggle,
  finishedSkillsets,
}: React.PropsWithChildren<PropsFromWithSkillSetSaving>) => {
  return (
    <EnterpriseUserSkillProfileContext.Provider
      value={{
        userSkillProfileStates,
        userSkillProfileStatesLoading,
        shouldRefetchUserSkillProfileStates,
        setShouldRefetchUserSkillProfileStates,
        onSkillSetSaveToggle,
        finishedSkillsets,
      }}
    >
      {children}
    </EnterpriseUserSkillProfileContext.Provider>
  );
};

export default compose<PropsFromWithSkillSetSaving, {}>(
  withProps(() => {
    const program = useProgram();
    const userId = User.get().id;

    return {
      program,
      userId,
    };
  }),
  withSkillSetSaving
)(EnterpriseUserSkillProfileProvider);
